import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from './main/main.component';
import { AuthGuardService, AuthTokenReceiver } from '../shared/services/auth/guard.service';

const routes: Routes = [
    {
        path: '',
        component: MainComponent,
        children: [
            { path: 'about', loadChildren: '../pages/about/about.module#AboutModule' },
            {
                path: 'subscription',
                loadChildren: '../pages/subscription/subscription.module#SubscriptionModule',
                canActivate: [AuthGuardService]
            },
            { path: '', loadChildren: '../pages/dashboard/dashboard.module#DashboardModule' },
            { path: '**', redirectTo: '/', pathMatch: 'full' }
        ],
        canActivate: [AuthTokenReceiver]
    },
    { path: '**', redirectTo: '/', pathMatch: 'full' }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    providers: [
        AuthGuardService,
        AuthTokenReceiver
    ]
})
export class MainRoutingModule { }
